import { TFunction } from 'i18next';
import { Button } from '@bbri/ui';
import React from 'react';
import { GraphPDFUtils } from '../../../../shared/utils/GraphPDFUtils';
import { FormType } from '../../../enum/FormType';
import { Diagram } from '../../../models/Diagram';
import { Dot } from '../../../models/Dot';
import { FormService } from '../../../services/FormService';
import FormDiagram from '../../FormDiagram';
import FormPVGraph from '../../FormPVGraph';

interface Props {
  graphInfo: Dot[] | string;
  diagramInfo: Diagram | null;
  diagramName: string;
  results: any[];
  t: TFunction;
  formType: FormType;
  formService: FormService;
  allComments: any;
}

export const FormResultGraphResultView: React.FC<Props> = ({
  graphInfo,
  diagramInfo,
  diagramName,
  results,
  t,
  formType,
  formService,
  allComments,
}) => {
  if (formType !== FormType.GRAPH) return null;

  return (
    <div>
      { Array.isArray(graphInfo) && graphInfo.length > 0 ? (
        <>
          <div style={{ display: "flex" }}>
            <h2 style={{ marginBottom: 10 }}>{formService.t(t, "ui_result_graph_title", false)}</h2>
          </div>
          <div>
            <div id="graph-result" >
              { results.map((r, i) =>
                r.requirementTitle !== 'submission_props' && (
                  <p key={i}>
                    <strong>{formService.t(t, r.requirementTitle, false)}</strong> : {formService.t(t, r.answer != null ? r.answer.toString().toLowerCase() : '', false)}
                  </p>
                )
              )}
            </div>
            <small >
              <i style={{ marginTop: "20px" }} className="pi pi-info-circle"/> {formService.t(t, "ui_graph_notes", false)}
            </small>
            <FormPVGraph graphs={[{
              title: diagramName,
              dots: graphInfo }]}>
            </FormPVGraph>
          </div>
        </>
      ) : (
        <>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <h2>{formService.t(t, "ui_result_graph_title", false)}</h2>
            <Button onClick={() => GraphPDFUtils.exportGraphPDF(
              formService.t(t, "title_app", true),
              formService.t(t, "ui_result_graph_title", false),
              formService.t(t, "ui_comparaison_table_title", false),
              formService.t(t, "ui_result_diagram_title", false),
              formService.t(t, 'logo_app', false, false, false, true),
              formService.t(t, 'bbri_logo', false, false, false, true)
            )}>PDF</Button>
          </div>
          <br/>
          <div id="graph-result" >
            {results.map((r, i) =>
                r.requirementTitle !== 'submission_props' && (
                  <p key={i}>
                    <strong>{formService.t(t, r.requirementTitle, false)}</strong> : {formService.t(t, r.answer != null ? r.answer.toString().toLowerCase() : '', false)}
                  </p>
                )
            )}
          </div>
        </>
      )}
      {diagramInfo && (
        <>
          <h2 style={{ marginBottom: 10, marginTop: 20 }}>{formService.t(t, "ui_result_diagram_title", true)}</h2>
          <FormDiagram diagram={diagramInfo}
                       comments={allComments}
                       editable={false}
          ></FormDiagram>
        </>
      )}
    </div>
  )
};
